// Auto-generated skeleton for ClientDatabase

import { ClientUnitQuota } from "./ClientUnitQuota";

export const ClientDatabase: Api.ClientDatabase = {
  id: 0,
  subdomain: '',
  is_xpa: false,
  host: null,
  port: 0,
  username: null,
  password: null,
  dbname: '',
  hp_id: null,
  quota: 0,
  used: 0,
  units_quota: ClientUnitQuota,
  units_used: 0,
  upload_locked: false,
  version: 0,
  created: null,
  updated: null,
};

